import { useTranslation } from 'react-i18next'

import type { DiscoveryDateRange } from '../filters/filters'

const DISCOVERY_DATE_PRESETS: readonly DiscoveryDateRange[] = [
  'any',
  'today',
  'tomorrow',
  'week',
  'month',
]

interface DiscoveryDatePresetsProps {
  value: DiscoveryDateRange
  onChange: (range: DiscoveryDateRange) => void
}

/**
 * The five upstream `3b39bc7` date chips. The filter sheet renders the same
 * values from `discovery.filters.dateRanges.*`, so there is one semantics and
 * one set of labels for both surfaces.
 */
export function DiscoveryDatePresets({
  value,
  onChange,
}: DiscoveryDatePresetsProps) {
  const { t } = useTranslation()

  return (
    <div
      className="category-rail"
      role="group"
      aria-label={t('discovery.datePresets.label')}
    >
      {DISCOVERY_DATE_PRESETS.map((range) => (
        <button
          key={range}
          type="button"
          className={`filter-chip date-chip ${value === range ? 'is-active' : ''}`}
          aria-pressed={value === range}
          onClick={() => onChange(range)}
        >
          {t(`discovery.filters.dateRanges.${range}`)}
        </button>
      ))}
    </div>
  )
}
